import React from 'react';
export function FinalCTA() {
  return <section className="py-12 sm:py-20 bg-[#0a1628] border-t border-gray-800 text-center" data-id="element-61">
      <div className="max-w-3xl mx-auto px-3 sm:px-6" data-id="element-62">
        <h2 className="text-2xl sm:text-4xl md:text-5xl font-black text-white mb-4 uppercase tracking-tight" data-id="element-63">
          ¿LISTO/A PARA DEJAR DE IMPROVISAR?
        </h2>

        <p className="text-base sm:text-xl text-gray-300 mb-6 font-medium" data-id="element-64">
          Unite a docentes que ya tienen su año completo de Metodología en
          Ciencias Sociales resuelto.
        </p>

        <a href="https://checkout.kitonline.shop/cart/47723025367278:1" className="inline-flex items-center justify-center bg-[#dc2626] hover:bg-red-700 text-white text-lg sm:text-2xl font-bold py-4 sm:py-5 px-8 sm:px-12 rounded-full shadow-[0_0_30px_rgba(220,38,38,0.6)] transition-all transform hover:scale-105 animate-pulse" data-id="element-65">
          👉 QUIERO EMPEZAR AHORA
        </a>
      </div>
    </section>;
}